export default {
    backendApiExternalUrl: 'https://admin.appoint.space/api',
};;